import { FunctionComponent } from 'preact';
import { NotificationsApiResponse } from '@novelizing/types';

export interface CommentOnYourChapterNotificationProps {
  notification: NotificationsApiResponse;
}

export const CommentOnYourChapterNotification: FunctionComponent<
  CommentOnYourChapterNotificationProps
> = ({ notification }) => {
  return (
    <a
      href={`/f/${notification.book?.permalink}/c/${notification.chapter?.permalink}/comments#${notification.comment?.id}`}
    >
      <p>
        <small>
          Comment on {notification.book?.title}: {notification.chapter?.title}
        </small>
      </p>
      <p>
        <small>
          by{' '}
          {notification.comment?.user?.name ||
            notification.comment?.user?.username}
        </small>
      </p>
      <p>{notification.content}</p>
    </a>
  );
};
